import containerSlice from "../slices/containerSlice";

export const {
  RequestContainerService,
  SuccessContainerService,
  FailureContainerService,
  RequestLiveResponsibles,
  SuccessLiveResponsibles,
  FailureLiveResponsibles,
  RequestContainerServices,
  SuccessContainerServices,
  FailureContainerServices,
  RequestInforService,
  SuccessInforService,
  FailureInforService,
  RequestVirshService,
  SuccessVirshService,
  FailureVirshService,
  RequestPodUpdate,
  SuccessPodUpdate,
  FailurePodUpdate,
  RequestPodRestart,
  SuccessPodRestart,
  FailurePodRestart,
  RequestGetAutoUpdateState,
  SuccessGetAutoUpdateState,
  FailureGetAutoUpdateState,
  RequestSetAutoUpdateState,
  SuccessSetAutoUpdateState,
  FailureSetAutoUpdateState,
  RequestBackendServiceConnected,
  SuccessBackendServiceConnected,
  FailureBackendServiceConnected,
  RequestUserServiceConnected,
  SuccessUserServiceConnected,
  FailureUserServiceConnected,
  RequestCheckExistingResponsibles,
  SuccessCheckExistingResponsibles,
  FailureCheckExistingResponsibles,
} = containerSlice.actions;
